module.exports = __webpack_public_path__ + "static/img/7.a5ec40a.png";


//////////////////
// WEBPACK FOOTER
// ./static/hz/7.png
// module id = O9MK
// module chunks = 202